import { AxleOrgSyncOrgFragment } from "../../../../../../types";
import { OrgsListBase, OrgsListBaseProps } from "./OrgsListBase";

type OrgsListUnlinkedProps = Omit<OrgsListBaseProps, "title" | "columnMode" | "onLink"> & {
  onLink: (org: AxleOrgSyncOrgFragment) => void;
};

export const OrgsListUnlinked = (props: OrgsListUnlinkedProps) => {
  return <OrgsListBase {...props} title="Unlinked Nutrition Orgs" columnMode={"Link"} />;
};
